module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/actions/send-to-ctc/send-to-ctc.component.scss
// module id = ./src/app/limit-flow-proposal/component/actions/send-to-ctc/send-to-ctc.component.scss
// module chunks = main